import { Component } from '@angular/core';
import {UntypedFormBuilder,UntypedFormGroup,Validators,} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../shared/api.service';
import { localStorageService } from '../../../shared/localstorage.service';
import { MainService } from '../../../shared/main.service';
import { SharedService } from '../../../shared/shared.service';
import { TwilioService } from 'src/app/components/shared/twilio.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
  public loginForm: UntypedFormGroup;
  public forgotPasswordForm: UntypedFormGroup;
  hidePwd: boolean = false;
  step = {
    EMAIL: 'EMAIL',
    PASSWORD: 'PASSWORD',
    VERIFY_OTP: 'VERIFY_OTP',
    FORGOT_PASSWORD: 'FORGOT_PASSWORD'
  };
  loginStep = this.step.EMAIL;
  interval: any;
  refreshTimer = '';
  // public isSubmitting = false;
  twilioData : any = this._local.customGetItem('twillio') ? this._local.customGetItem('twillio') : '';
  returnUrl: string = '';

  constructor(private fb: UntypedFormBuilder, public _shared: SharedService, private _main: MainService, private _api: ApiService, private _local: localStorageService, private _router: Router, private _route: ActivatedRoute, public _twilio: TwilioService) {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.maxLength(100)]],
      password: [''],
      otp: [''],
    });
    this.forgotPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.maxLength(100)]],
    });
    const returnUrl = this._route.snapshot.queryParamMap.get('returnUrl');
    this.returnUrl = returnUrl && returnUrl.startsWith('/') && !returnUrl.startsWith('//') ? returnUrl : '';
  }
  public login(event?: KeyboardEvent) {
    // if (event) {
    //   event.preventDefault();
    //   event.stopPropagation();
    // }
    // if (this.isSubmitting) {
    //   return;
    // }
    if (!this.loginForm.value.email) {
      this._shared.customPopups('Please enter valid email', 1);
      return;
    }
    if (this.loginStep == this.step.VERIFY_OTP) {
      if (!this.loginForm.value.otp) {
        this._shared.customPopups('Please enter valie otp', 1);
        return;
      }  
    } else {
      if (!this.loginForm.value.password) {
        this._shared.customPopups('Please enter valid password', 1);
        return;
      }
    }

    let data: any = {
      admin_email: this.loginForm.value.email ? this.loginForm.value.email.trim() : '',
    };

    if (this.loginStep == this.step.VERIFY_OTP) {
      data['otp'] = this.loginForm.value.otp;
    } else {
      data['admin_password'] = this._shared.crypto(this.loginForm.value.password)
    }

    // this.isSubmitting = true;


    this._api.api(data, 'auth/email_login').subscribe((response: any) => {
      if (!response.is_error) {
        if (response.reset_password_token){
          if (response.reset_password_token) {
            navigator.geolocation.getCurrentPosition(() => {});
            this._local.customSetItem('token', response.access_token);
            this._local.customSetItem('reset_password_token', response.reset_password_token);
            this._local.customSetItem('reset_email', response.admin_email);
            this._router.navigate(['new-password']);
            return;
          }
        } else {
          navigator.geolocation.getCurrentPosition(() => {});
          this._local.customClearAllItems();
          this._local.customSetItem('token', response.access_token);
          this._local.customSetItem('admin_profile', response.admin_profile ? response.admin_profile[0] : {});
          this._local.customSetItem('twillio', response.twilio);
          if (response.engagement_allowed_role_ids) {
            this._local.customSetItem('engagement_allowed_role_ids', response.engagement_allowed_role_ids);
          }
          this.requestMicrophone();
          // const phone_no = response.admin_profile[0].admin_mobile && Array.isArray(response.twilio) && response.twilio.some((x: any) => x.twilio_mobile === response.admin_profile[0].admin_mobile) ? response.admin_profile[0].admin_mobile : '';
          // if (phone_no && !this._twilio.twilioInitiated) {
          //   if (response.admin_profile[0].role_id != 13 || response.admin_profile[0].role_id != 1 || response.admin_profile[0].role_id != 4) {
          //     this._twilio.initTwilio(phone_no);
          //   }
          // }
          this._main.fetchAdminList();
          this._main.getAdminName();
          if (response.menu && response.menu.length) {
            this._main.menu$.next(response.menu);
          }
          if (this.returnUrl) {
            this._router.navigateByUrl(this.returnUrl);
          } else {
            this._router.navigate(['app', 'dashboard']);
          }
        }
      }
    })
  }
  forgotPassword() {
    if (this.forgotPasswordForm.invalid) {
      this.forgotPasswordForm.markAsDirty();
      this.forgotPasswordForm.markAllAsTouched();
      return;
    }

    const data = {
      admin_email: this.forgotPasswordForm.value.email ? this.forgotPasswordForm.value.email.trim() : ''
    };

    this._api.api(data, 'auth/forgot_password').subscribe(response => {
      if (!response.is_error) {
        this.forgotPasswordForm.reset();
        this._shared.customPopups('Password has been sent successfully', 0);
        this.loginStep = this.step.EMAIL;
      }
    })
  }
  requestMicrophone() {
  navigator.mediaDevices.getUserMedia({ audio: true })
    .then(stream => {
      console.log("Microphone permission granted");
      stream.getTracks().forEach(t => t.stop());
    })
    .catch(err => {
      console.error("Microphone permission denied:", err);
    });
}
  changeloginStep(type: any) {
    if (type === this.step.PASSWORD || type === this.step.VERIFY_OTP) {
      if (!this.loginForm.controls['email'].value) {
        this.loginForm.markAsDirty();
        this.loginForm.markAllAsTouched();
        return;
      } else {
        if (type === this.step.PASSWORD) {
          this.loginStep = type;
        } else if (type === this.step.VERIFY_OTP) {
          if (!this.loginForm.value.email) {
            this._shared.customPopups('Please enter valid email', 1);
            return;
          }
          const data = {
            admin_email: this.loginForm.value.email ? this.loginForm.value.email.trim() : ''
          };
          this._api.api(data, 'auth/auth_otp').subscribe(response => {
            if (!response.is_error) {
              this.loginStep = type;
              this.countDown(90);
            }
          })
        } else {
          console.log('Invalid Type');
        }
      }
    } else if (type === this.step.EMAIL){
      this.loginStep = type;
      this.clearCountDown();
    }
  }
  clearCountDown() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
      this.refreshTimer = '';
    }
  }
  countDown(time?: any): void {
    let duration: number;
    duration = time;
    this.clearCountDown(); 
    this.interval = setInterval(() => {
      const minutes = parseInt((duration / 60).toString());
      const seconds = parseInt((duration % 60).toString());
      this.refreshTimer = (minutes < 10 ? '0' + minutes : minutes) + 'm' + ':' + (seconds < 10 ? '0' + seconds : seconds) + 's';
      duration--;
      if (duration < 0) {
        this.clearCountDown();
      }
    }, 1000);
  }
}
